(function () {
  const CONFIG = window.AUTO_GIFT_CONFIG || {};
  const collectionCache = {};
  let isSyncingGift = false;

  function cartUrl(path) {
    return `${window.Shopify.routes.root}${path}`;
  }

  async function getCart() {
    const response = await fetch(cartUrl("cart.js"), {
      headers: { Accept: "application/json" },
    });

    return response.json();
  }

  async function getCollectionProductIds(collectionHandle) {
    if (collectionCache[collectionHandle]) {
      return collectionCache[collectionHandle];
    }

    let page = 1;
    let productIds = [];
    let hasMore = true;

    while (hasMore) {
      const response = await fetch(
        `/collections/${collectionHandle}/products.json?limit=250&page=${page}`,
        {
          headers: { Accept: "application/json" },
        }
      );

      if (!response.ok) break;

      const data = await response.json();
      const products = data.products || [];

      productIds = productIds.concat(products.map((product) => product.id));

      hasMore = products.length === 250;
      page++;
    }

    collectionCache[collectionHandle] = productIds;
    return productIds;
  }

  function findGiftItem(cart, giftVariantId) {
    return cart.items.find(function (item) {
      return Number(item.variant_id) === Number(giftVariantId);
    });
  }

  function findAutoGiftItem(cart, giftConfig) {
    return cart.items.find(function (item) {
      return (
        Number(item.variant_id) === Number(giftConfig.giftVariantId) &&
        item.properties &&
        item.properties._auto_gift_id === giftConfig.id
      );
    });
  }

  async function qualifiesForGift(cart, giftConfig) {
    const collectionProductIds = await getCollectionProductIds(
      giftConfig.collectionHandle
    );

    const subtotal = cart.items.reduce(function (total, item) {
      const isGift =
        Number(item.variant_id) === Number(giftConfig.giftVariantId);

      const belongsToCollection = collectionProductIds.includes(
        Number(item.product_id)
      );

      if (isGift || !belongsToCollection) {
        return total;
      }

      return total + item.final_line_price;
    }, 0);

    return subtotal >= Number(giftConfig.minCartTotal);
  }

 async function addGift(giftConfig) {
    try {
      const response = await fetch(cartUrl("cart/add.js"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: giftConfig.giftVariantId,
          quantity: giftConfig.giftQuantity || 1,
          properties: {
            _auto_gift: "true",
            _auto_gift_id: giftConfig.id,
          },
        }),
      });

      if (!response.ok) {
        const error = await response.json().catch(function () {
          return null;
        });

        console.warn(
          "No se pudo agregar el regalo automático. Puede estar sin inventario, inactivo o no disponible en la tienda online.",
          error
        );

        return false;
      }

      return true;
    } catch (error) {
      console.warn("Error inesperado al agregar regalo automático:", error);
      return false;
    }
  }

  async function removeGift(giftItem, giftConfig) {
    const qtyToRemove = giftConfig.giftQuantity || 1;
    const newQuantity = Math.max(0, giftItem.quantity - qtyToRemove);

    return fetch(cartUrl("cart/change.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: giftItem.key,
        quantity: newQuantity,
      }),
    });
  }

  async function syncAutoGift() {
    if (isSyncingGift) return;
    if (!CONFIG.enabled || !Array.isArray(CONFIG.gifts)) return;

    try {
      isSyncingGift = true;

      const cart = await getCart();
      let cartChanged = false;

      for (const giftConfig of CONFIG.gifts) {
        if (
          !giftConfig.id ||
          !giftConfig.collectionHandle ||
          !giftConfig.giftVariantId ||
          !giftConfig.minCartTotal
        ) {
          continue;
        }

        const qualifies = await qualifiesForGift(cart, giftConfig);
        const anyGiftItem = findGiftItem(cart, giftConfig.giftVariantId);
        const autoGiftItem = findAutoGiftItem(cart, giftConfig);

        if (qualifies && !anyGiftItem) {
          await addGift(giftConfig);
          cartChanged = true;
          break;
        }

        if (!qualifies && autoGiftItem) {
          await removeGift(autoGiftItem, giftConfig);
          cartChanged = true;
          break;
        }
      }

      if (cartChanged) {
            document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", { bubbles: true })
            );

            document.documentElement.dispatchEvent(
                new CustomEvent("cart:updated", { bubbles: true })
            );
        }
    } catch (error) {
      console.error("Auto gift error:", error);
    } finally {
      isSyncingGift = false;
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    syncAutoGift();
  });

  document.addEventListener("submit", function (event) {
    const form = event.target;

    if (form.matches('form[action*="/cart/add"]')) {
      setTimeout(syncAutoGift, 1200);
    }
  });

  document.addEventListener("change", function (event) {
    const target = event.target;

    if (
      target.matches('input[name="updates[]"]') ||
      target.matches('input[name^="updates"]') ||
      target.matches('select[name="updates[]"]')
    ) {
      setTimeout(syncAutoGift, 800);
    }
  });

  document.addEventListener("click", function (event) {
    const target = event.target.closest(
      'button, a, [data-cart-remove], [data-cart-update], [name="minus"], [name="plus"]'
    );

    if (target) {
      setTimeout(syncAutoGift, 1000);
    }
  });
})();